export default __webpack_public_path__ + "static/media/Icon18.3739f552.svg";